module.exports = __webpack_public_path__ + "static/img/7.53bbf20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/7.png
// module id = Q9o3
// module chunks = 0